__turbopack_context__.v({
  "container": "PreviewLabel-module-scss-module__7u6Yvq__container",
  "exitButton": "PreviewLabel-module-scss-module__7u6Yvq__exitButton",
  "label": "PreviewLabel-module-scss-module__7u6Yvq__label",
});
